import React, { Component } from "react";
import { connect } from "react-redux";

import {
  showAddToHomeScreen,
  hideAddToHomeScreen
} from "../../store/actionCreators/addToHomeScreen";
import CustomSnackBar from "./CustomSnackBar";

class AddToHomeScreenWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: this.processData(props)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.addToHomeScreen !== nextProps.addToHomeScreen) {
      this.setState({ open: this.processData(nextProps) });
    }
  }

  processData = props => {
    let open = props.addToHomeScreen;
    if (open) {
      const { beforeInstallPromptEvent, dontPromptAgain } =
        window["_private"] || {};
      if (!beforeInstallPromptEvent || dontPromptAgain) {
        open = false;
      }
    }

    if (open) {
      window["_private"]["dontPromptAgain"] = true;
    }
    return open;
  };

  addToHomeScreen = () => {
    this.props.hideAddToHomeScreen();
    const { beforeInstallPromptEvent } = window["_private"] || {};
    if (beforeInstallPromptEvent) {
      beforeInstallPromptEvent.prompt();
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <CustomSnackBar
        open={this.state.open}
        message="Add to Home screen"
        buttonText="ADD"
        handleClose={this.props.hideAddToHomeScreen}
        handleClick={this.addToHomeScreen}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    addToHomeScreen: state.addToHomeScreen
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showAddToHomeScreen: () => {
      dispatch(showAddToHomeScreen());
    },
    hideAddToHomeScreen: () => {
      dispatch(hideAddToHomeScreen());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddToHomeScreenWrapper);



// WEBPACK FOOTER //
// ./src/components/Utils/AddToHomeScreenWrapper.js